import {ChangeDetectorRef, Component, OnInit, Renderer2} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {SiteTextConstants} from '../global/site-text.constants';
import {CourseService} from '../shared/course.service';
import {GradingScheduleService} from '../shared/grading-schedule.service';
import {GradingScheduleList} from '../shared/interface/grading-schedule.interface';
import {GenericFormGroupComponent} from '../forms/generic-form-group.component';

@Component({
    selector: 'app-instructor',
    templateUrl: './instructor.component.html',
    styleUrls: ['./instructor.component.scss']
})
export class InstructorComponent extends GenericFormGroupComponent implements OnInit {
    constructor(
        private dialog: MatDialog,
        private gradingScheduleService: GradingScheduleService,
        private courseService: CourseService,
        protected render2: Renderer2,
        private changeDetectRef: ChangeDetectorRef
    ) {
        dialog.closeAll();
        super(render2);
    }

    enableTermDropDown: boolean = false;
    currentTermCode: string;
    currentSection: string;
    currentPage: string = SiteTextConstants.InstructorCourseListPage;
    currentSchedule: GradingScheduleList;
    showTermNotAvailable: boolean = true;
    ngOnInit(): void {
        if (!this.currentTermCode) {
            this.currentTermCode = this.courseService.currentTerm;
            this.getScheduleData(this.currentTermCode);
        }
        if (!this.currentSection) {
            this.currentSection = this.courseService.section;
        }
        if (!this.currentTermCode) {
            this.gradingScheduleService.getCurrentTerm().subscribe((response: GradingScheduleList) => {
                this.currentSchedule = response;
                this.currentTermCode = response.termCode;
            });
        }
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.changeDetectRef.detectChanges();
    }

    getScheduleData(termCode: string) {
        console.log(termCode);
        if (termCode) {
            this.gradingScheduleService.get(termCode).subscribe((response: GradingScheduleList) => {
                this.currentSchedule = response[0];
                console.log(this.currentSchedule);
            });
        }
    }

    updateSelectedTermCode(selectedTermCode: string): void {
        console.log('selected => ' + selectedTermCode);
        this.currentTermCode = selectedTermCode;
        this.getScheduleData(this.currentTermCode);
    }

    updateCourseDataLoaded(dataLoadStatus: boolean) {
        // if dataLoadStatus is true means data loaded
        // we enable drop down  we do not want to disable drop down
        this.enableTermDropDown = dataLoadStatus;
        this.changeDetectRef.detectChanges();
    }

    ngOnChanges() {
        this.getScheduleData(this.currentTermCode);
    }

    updateSection($event: string) {
        this.courseService.setCurrentSection($event);
        this.currentSection = $event;
    }
}
